import React, { useContext, useState, Fragment, useEffect } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthLessThan,
  isNumeric,
  hasLengthGreaterThan, matchesPattern
} from "revalidate";
import { observer } from "mobx-react-lite";
import { toast } from "react-toastify";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { IClientForm } from "../../../app/models/client";
import TextInput from "../../../app/common/form/TextInput";
import SelectInput from "../../../app/common/form/SelectInput";
import { PlanTypeEnumOptions } from "../../../app/util/securityEnumsOptions";
import { Role } from "../../../app/util/role";

const validate = combineValidators({
  companyID: composeValidators(
    isRequired({ message: "El NIT es obligatorio" }),
    isNumeric({ message: "El NIT debe ser numerico" }),
    hasLengthGreaterThan(6)({
      message: "El NIT debe tener al menos 7 caracteres",
    }),
    hasLengthLessThan(11)({
      message: "El NIT debe tener máximo 10 caracteres",
    })
  )(),
  registrationName: composeValidators(
    isRequired({ message: "El Nombre o Razón Social es obligatorio" }),
    hasLengthGreaterThan(1)({
      message: "El Nombre o Razón Social debe tener al menos 2 caracteres",
    }),
    hasLengthLessThan(257)({
      message: "El Nombre o Razón Social debe tener máximo 256 caracteres",
    }),
    matchesPattern(/^[A-zÀ-ÿ0-9 '.,;:&_@\-]*$/)({
      message:
        "Nombre no válido. Contiene caracteres especiales diferente a: ' . , ; : & _ @",
    })
  )(),
  planType: composeValidators(
    isRequired({ message: "El Plan es obligatorio" })
  )(),
});

const NewClientForm = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { newClient, btEditClient } = rootStore.clienStore;
  const { user } = rootStore.userStore;
  const { getSellersOption, sellersOption } = rootStore.sellerStore;

  useEffect(() => {
    if (user?.role === Role.Sudo) getSellersOption();
  }, [getSellersOption, user]);

  const [newClientForm] = useState<IClientForm>({
    sellerId: "",
    companyID: "",
    registrationName: "",
    planType: "",
  });

  const handleFinalFormSubmit = (values: any) => {
    if (
      values.sellerId !== newClientForm.sellerId ||
      values.companyID !== newClientForm.companyID ||
      values.registrationName !== newClientForm.registrationName ||
      values.planType !== newClientForm.planType
    ) {
      newClientForm.companyID = values.companyID.trim();
      newClientForm.registrationName = values.registrationName.trim();
      newClientForm.planType = values.planType;
      newClientForm.sellerId = values.sellerId;
      newClient(newClientForm);
    } else toast.error("No ha hecho ningún cambio");
  };

  return (
    <div className="tabContentStyle">
      <FinalForm
        validate={validate}
        initialValues={newClientForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Nombre o Razón Social del emisor</label>
              <Field
                name="registrationName"
                value={newClientForm.registrationName}
                component={TextInput}
              />
              <label>NIT del emisor</label>
              <Field
                name="companyID"
                value={newClientForm.companyID}
                component={TextInput}
              />
              <label>Plan</label>
              <Field
                name="planType"
                component={SelectInput}
                placeholder="Seleccionar plan"
                options={PlanTypeEnumOptions}
              />
              {user?.role === Role.Sudo && (
                <Fragment>
                  <label>Vendedor</label>
                  <Field
                    name="sellerId"
                    component={SelectInput}
                    placeholder="Seleccionar vendedor"
                    options={sellersOption}
                  />
                </Fragment>
              )}
            </Container>
            <br />
            <Button
              loading={btEditClient}
              disabled={btEditClient}
              className="ui primary button"
              color="blue"
              type="submit"
              content="Guardar"
            />
          </Form>
        )}
      />
    </div>
  );
};

export default observer(NewClientForm);
